import api from "@/libs/axios";
import * as ep from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: {
    aboutContent: "",
    loading: false,
    working: false,
  },
  getters: {
    aboutContent(state) {
      return state.aboutContent;
    },

    loading(state) {
      return state.loading;
    },
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setData(state, val) {
      state.aboutContent = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setWorking(state, val) {
      state.working = val;
    },
  },
  actions: {
    async fetchAboutContent({ commit }) {
      commit("setLoading", true);
      await api
        .get(ep.ABOUT_CONTENT)
        .then((res) => {
          if (res.status >= 200 && res.status <= 300)
            commit("setData", res.data.data.about);
        })
        .finally(() => {
          commit("setLoading", false);
        });
    },
    async updateAboutContent({ commit, dispatch }, content) {
      commit("setWorking", true);

      await api
        .put(ep.ABOUT_CONTENT_UPDATE, { about: content })
        .then((res) => {
          if (res.status >= 200 && res.status <= 300) {
            this._vm.$toast({
              component: ToastificationContent,
              props: {
                title: "تم التعديل بنجاح",
                icon: "CheckSquareIcon",
                variant: "success",
                timeout: 3000,
              },
            });
            dispatch("fetchAboutContent");
          } else {
            this._vm.$toast({
              component: ToastificationContent,
              props: {
                title: "حدث خطأ أثناء تنفيذ العملية",
                icon: "AlertIcon",
                variant: "danger",
                timeout: 3000,
              },
            });
          }
        })
        .finally(() => {
          commit("setWorking", false);
        });
    },
  },
};
